import Tab from './tab.component';
import TabPanel from './tab.panel';
import TabControl from './tab.controller';

export default {
  Root: Tab,
  TabControl,
  TabPanel,
};
